/* eslint-disable */ import { entities as v1 } from './versions/v1.js';
export * from './versions/v1.js';
export const modelVersions = {
    1: v1
};

//# sourceMappingURL=index.js.map